var _excluded = ["icon", "type"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Input } from 'reactstrap';
import { _Icon as Icon } from "../core/common";
var InputWever = function InputWever(_ref) {
  var icon = _ref.icon,
    type = _ref.type,
    args = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "userapp-wever-input d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(Icon, {
    name: icon,
    className: "input-icon"
  }), /*#__PURE__*/React.createElement(Input, _extends({
    type: type
  }, args)));
};
export default InputWever;